import { Sparkles } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useNotifications } from "@/hooks/useNotifications";
import { formatDistanceToNow } from "date-fns";

interface Props {
  notification: ReturnType<typeof useNotifications>["notifications"][0];
  isUnread: boolean;
  onClose: () => void;
}

export function ExpertReviewPendingNotificationItem({ notification, isUnread, onClose }: Props) {
  const navigate = useNavigate();
  const { markAsRead } = useNotifications();
  const data = (notification.data ?? {}) as {
    outlet_name?: string;
    entity_name?: string;
    submitter_name?: string;
  };

  const handleClick = () => {
    if (isUnread) markAsRead();
    onClose();
    navigate("/admin/expert-reviews");
  };

  return (
    <button
      onClick={handleClick}
      className={`w-full text-left p-3 rounded-lg flex items-start gap-3 hover:bg-accent transition ${
        isUnread ? "bg-accent/40" : ""
      }`}
    >
      <div className="h-9 w-9 rounded-full bg-primary/10 flex items-center justify-center shrink-0">
        <Sparkles className="h-4 w-4 text-primary" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-sm">
          <span className="font-medium">{data.submitter_name ?? "Someone"}</span> suggested an expert
          review from <span className="font-medium">{data.outlet_name ?? "an outlet"}</span> for{" "}
          <span className="font-medium">{data.entity_name ?? "an entity"}</span>
        </p>
        <p className="text-xs text-muted-foreground mt-0.5">
          {formatDistanceToNow(new Date(notification.created_at), { addSuffix: true })}
        </p>
      </div>
      {isUnread && <span className="h-2 w-2 rounded-full bg-primary mt-2 shrink-0" />}
    </button>
  );
}
